import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components';
import {CgMenu} from 'react-icons/cg';
import {CgClose} from 'react-icons/cg';
import { Button } from '../styles/Button';

const Navbar = () => {

  const [openMenu, setMenu] = useState(false);
  const Nav = styled.nav`
  .navbar-list{
    display:flex;
    align-items: center;
    gap:4.8rem;
     
    li{
      list-style:none;
      .navbar-link{
        &:link, 
        &:visited{
          display:inline-block;
          text-decoration:none;
          font-size: 1.8rem;
          text-transform: uppercase;
          color: ${({theme}) => theme.colors.black};
          transition: color 0.3s linear;
        }

        &:hover, &:active{
          color: ${({theme})=> theme.colors.helper}
        } 
      
      }
    }
    

  }

  .mobile-navbar-btn{
    display: none;

    .close-outline{
      display: none;
    }

  }
  .mobile-navbar-btn[name="close-outline"]{
    display: none;

  }
    
  @media (max-width: ${({theme})=>theme.media.mobile}){

    .mobile-navbar-btn{
      display: inline-block;
      z-index: 999;
      border: ${({theme})=>theme.colors.black};

      


    }
    .mobile-nav-icons{
        font-size: 4.2rem;
        color: ${({theme})=>theme.colors.black};
        
    }



    .navbar-list{
      width: 100vw;
      height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #fff;

      display: flex;
      justify-content: center;      
      align-content: center;
      flex-direction: column;
      text-align: center;
      
     

      transform: translateX(100%);
      visibility: hidden;
      opacity: 0;
     li{
      .navbar-link{
        &:link, 
        &:visited{
         
          font-size: 4.2rem;
          
        }

        &:hover, &:active{
          color: ${({theme})=> theme.colors.helper}
        } 
      
      }
     }
    }
    .active .mobile-nav-icons{
      display: none;
      font-size: 4.2rem;
      position: absolute;
      top: 3%;
      right:10%;
      color: ${({theme})=>theme.colors.black};
      z-index: 9999;
    }

    .active .close-outline {
      display: inline-block !important;
    }

    .active .navbar-list{
      visibility: visible;
      opacity: 1;
      transform: translateX(0);
      z-index: 999;
    }


      

    

   }





  `;
  return (
    <Nav>
      <div className={ openMenu ? " menuIcon active " : "menuIcon"}>
        <ul className='navbar-list'>
          <li>
            <NavLink  className='navbar-link' to="/" onClick={() => setMenu(false)}>Home</NavLink>
          </li>

          <li>
            <NavLink  className='navbar-link' to="/about" onClick={() => setMenu(false)}>About</NavLink>
          </li>

          <li>
            <NavLink  className='navbar-link' to="/services" onClick={() => setMenu(false)}>Services</NavLink>
          </li>

          <li>
            <NavLink  className='navbar-link' to="/contact" onClick={() => setMenu(false)}>Contact</NavLink>
          </li>
          <li>
            <NavLink  className='navbar-link' to="/login" onClick={() => setMenu(false)}><Button>Login</Button></NavLink>
          </li>
          <li>
            <NavLink  className='navbar-link' to="/Register" onClick={() => setMenu(false)}><Button>Register</Button></NavLink>
          </li>

          
        </ul>
        <div className='mobile-navbar-btn'>
          <CgMenu name='menu-outline' className="mobile-nav-icons" onClick={() => setMenu(true)}/>
          <CgClose name="close-outline" className="close-outline mobile-nav-icons"  onClick={() => setMenu(false)}/>
        </div>
      </div>
    </Nav>
  );

  
}

export default Navbar